import { makeStyles } from 'tss-react/mui'
import { lato } from '@styles/fonts'
import { nunito_sans } from '@styles/fonts'
import bgTransparent from 'src/assets/images/press/bgTransparent.png'
const useStyles = makeStyles()((theme) => ({
  imgWrapper: {
    background: `url(${bgTransparent.src})`,
    backgroundSizee: 'cover',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(14),
    borderRadius: '20px',
    height: '150px',
    [theme.breakpoints.down('md')]: {
      borderRadius: '16px',
      marginTop: theme.spacing(8),
    },
  },
  image: {
    width: '100%',
  },
  logos: {
    width: 'fit-content',
    height: 'auto',
  },
  descWrapper: {
    display: 'flex',
    // justifyContent: 'space-between',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(4, 0, 0),
    img: {
      cursor: 'pointer',
    },
  },

  title: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '16px',
    textAlign: 'start',
    lineHeight: '19px',
    textTransform: 'uppercase',
    color: theme.custom.blackColor,
    paddingRight: theme.spacing(3),

    [theme.breakpoints.down('md')]: {
      // fontSize: '32px',
      // lineHeight: '83px',
    },
  },
  type: {
    fontFamily: lato.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    textAlign: 'start',
    lineHeight: '19px',
    color: theme.custom.blackColor,
    // padding: theme.spacing(4, 0, 0),
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      // padding: theme.spacing(2, 0, 0),
      lineHeight: '17px',
    },
  },
}))

export default useStyles
